import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createComment as universalCreateComment, getComment as universalGetComment, updateComment as universalUpdateComment, deleteComment as universalDeleteComment, moderateDraftContent as universalModerateDraftContent, queryComments as universalQueryComments, markComment as universalMarkComment, unmarkComment as universalUnmarkComment, hideComment as universalHideComment, publishComment as universalPublishComment, countComments as universalCountComments, listCommentsByResource as universalListCommentsByResource, getCommentThread as universalGetCommentThread, bulkPublishComment as universalBulkPublishComment, bulkHideComment as universalBulkHideComment, bulkDeleteComment as universalBulkDeleteComment, bulkModerateDraftContent as universalBulkModerateDraftContent, bulkMoveCommentByFilter as universalBulkMoveCommentByFilter, } from './comments-v2-comment.universal';
import { NodeType, WidthType, PluginContainerDataAlignment, Type, Target, TextAlignment, LineStyle, Width, Alignment, ViewMode, LayoutType, Orientation, Crop, ThumbnailsAlignment, Source, MapType, ViewRole, VoteRole, PollLayoutType, PollLayoutDirection, BackgroundType, DecorationType, FontType, AppType, InitialExpandedItems, Direction, VerticalAlignment, NullValue, Status, VersioningMode, Action, SortOrder, Order, ReplySortOrder, WebhookIdentityType, } from './comments-v2-comment.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.comments.v2.comment', module_name: 'wix-comments.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createComment: (comment, options) => {
            const methodLogData = {
                method_name: 'createComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.createComment',
            };
            return universalCreateComment(comment, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getComment: (commentId) => {
            const methodLogData = {
                method_name: 'getComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.getComment',
            };
            return universalGetComment(commentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateComment: (_id, comment) => {
            const methodLogData = {
                method_name: 'updateComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.updateComment',
            };
            return universalUpdateComment(_id, comment, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteComment: (commentId, options) => {
            const methodLogData = {
                method_name: 'deleteComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.deleteComment',
            };
            return universalDeleteComment(commentId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        moderateDraftContent: (commentId, revision, options) => {
            const methodLogData = {
                method_name: 'moderateDraftContent',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.moderateDraftContent',
            };
            return universalModerateDraftContent(commentId, revision, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryComments: (appId) => {
            const methodLogData = {
                method_name: 'queryComments',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.queryComments',
            };
            return universalQueryComments(appId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        markComment: (commentId, options) => {
            const methodLogData = {
                method_name: 'markComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.markComment',
            };
            return universalMarkComment(commentId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        unmarkComment: (commentId, options) => {
            const methodLogData = {
                method_name: 'unmarkComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.unmarkComment',
            };
            return universalUnmarkComment(commentId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        hideComment: (commentId) => {
            const methodLogData = {
                method_name: 'hideComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.hideComment',
            };
            return universalHideComment(commentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        publishComment: (commentId) => {
            const methodLogData = {
                method_name: 'publishComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.publishComment',
            };
            return universalPublishComment(commentId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        countComments: (appId, options) => {
            const methodLogData = {
                method_name: 'countComments',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.countComments',
            };
            return universalCountComments(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listCommentsByResource: (appId, options) => {
            const methodLogData = {
                method_name: 'listCommentsByResource',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.listCommentsByResource',
            };
            return universalListCommentsByResource(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCommentThread: (commentId, options) => {
            const methodLogData = {
                method_name: 'getCommentThread',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.getCommentThread',
            };
            return universalGetCommentThread(commentId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkPublishComment: (appId, options) => {
            const methodLogData = {
                method_name: 'bulkPublishComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.bulkPublishComment',
            };
            return universalBulkPublishComment(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkHideComment: (appId, options) => {
            const methodLogData = {
                method_name: 'bulkHideComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.bulkHideComment',
            };
            return universalBulkHideComment(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteComment: (appId, options) => {
            const methodLogData = {
                method_name: 'bulkDeleteComment',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.bulkDeleteComment',
            };
            return universalBulkDeleteComment(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkModerateDraftContent: (appId, options) => {
            const methodLogData = {
                method_name: 'bulkModerateDraftContent',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.bulkModerateDraftContent',
            };
            return universalBulkModerateDraftContent(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkMoveCommentByFilter: (appId, options) => {
            const methodLogData = {
                method_name: 'bulkMoveCommentByFilter',
                service_name: 'wix.comments.ng.v1.CommentsNg',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-comments.v2,entity=wix.comments.v2.comment,environment=velo-frontend,method-fqn=wix.comments.ng.v1.CommentsNg.bulkMoveCommentByFilter',
            };
            return universalBulkMoveCommentByFilter(appId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        NodeType,
        WidthType,
        PluginContainerDataAlignment,
        Type,
        Target,
        TextAlignment,
        LineStyle,
        Width,
        Alignment,
        ViewMode,
        LayoutType,
        Orientation,
        Crop,
        ThumbnailsAlignment,
        Source,
        MapType,
        ViewRole,
        VoteRole,
        PollLayoutType,
        PollLayoutDirection,
        BackgroundType,
        DecorationType,
        FontType,
        AppType,
        InitialExpandedItems,
        Direction,
        VerticalAlignment,
        NullValue,
        Status,
        VersioningMode,
        Action,
        SortOrder,
        Order,
        ReplySortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=comments-v2-comment.frontend.js.map